import gql from 'graphql-tag';
import { getGraphQLClientAPVendorDBWithToken } from 'utils/apiRequests';

//Below two are helper functions for fieldname errors for graphql 2.4.0
function lowercaseFirstChar(obj) {
	const newObj = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			const newKey = key.charAt(0).toLowerCase() + key.slice(1);
			if (typeof value === 'object' && !Array.isArray(value)) {
				// Recursively lowercase first character of field names of nested objects
				newObj[newKey] = lowercaseFirstChar(value);
			} else {
				newObj[newKey] = value;
			}
		}
	}

	// Remove the "filterTo" and "dateTo" property if it exists
	delete newObj.filterTo;
	delete newObj.dateTo;

	return newObj;
}

const exploreLibraryQuery = (request, columns, thresholdCount) => {
	if (Object.keys(request.filterModel).length === 0) {
		request.filterModel = {
			is_Reviewed: {
				filterType: 'text',
				type: 'equals',
				filter: '0',
			},
		};
	} else {
		const isReviewedPresent = 'is_Reviewed' in request.filterModel;
		if (!isReviewedPresent) {
			let oldFilterOptions = request.filterModel;
			oldFilterOptions.is_Reviewed = {
				filterType: 'text',
				type: 'equals',
				filter: '0',
			};
		}
	}

	const fields = columns.map(col => col.field);
	return {
		query: gql`
			query aPVendorData(
					$start: Int!, 
					$end: Int!, 
					$sortModel: [SortModelType!], 
					$filterModel:[FilterModelType!],
					$groupKeys: [String!],
					$rowGroups:[RowGroupModelType!],
					$valueCols:[ValueColsModelType!],
					$havingModel:[HavingModelType!],
				  ) {
					  aPVendorData(
					startRow: $start,    
					endRow: $end,
					sorting: $sortModel,
					filterModel:$filterModel,
					groupKeys: $groupKeys,  
					rowGroups:$rowGroups,
					valueCols:$valueCols,
					havingModel:$havingModel
				  ) {
					${[...fields]}
				}
			}
		`,
		variables: {
			start: request.startRow,
			end: request.endRow,
			sortModel: request.sortModel,
			filterModel: [lowercaseFirstChar(request.filterModel)],
			rowGroups: [
				{
					id: '0',
					aggFunc: 'count',
					displayName: 'NormalizedVendorName',
					field: 'NormalizedVendorName',
				},
				{
					id: '1',
					aggFunc: 'count',
					displayName: 'AP_L1Category',
					field: 'AP_L1Category',
				},
				{
					id: '2',
					aggFunc: 'count',
					displayName: 'AP_L2Category',
					field: 'AP_L2Category',
				},
				{
					id: '3',
					aggFunc: 'count',
					displayName: 'AP_L3Category',
					field: 'AP_L3Category',
				},
				{
					id: '3',
					aggFunc: 'count',
					displayName: 'AP_L4Category',
					field: 'AP_L4Category',
				},
				{
					id: '3',
					aggFunc: 'count',
					displayName: 'ClassificationFlag',
					field: 'ClassificationFlag',
				},
				{
					id: '3',
					aggFunc: 'count',
					displayName: 'Is_Reviewed',
					field: 'Is_Reviewed',
				},
			],
			valueCols: [
				{
					id: '0',
					aggFunc: 'count',
					displayName: 'AliasName',
					field: 'AliasName',
				},
			],
			groupKeys: [],
			havingModel: [
				{
					id: '0',
					aggFunc: 'count',
					displayName: 'AliasName',
					field: 'AliasName',
					type: 'greaterThanOrEqual',
					value: String(thresholdCount),
					filterType: 'number',
				},
			],
		},
	};
};

//this function makes columns from the data
const ServerSideDataSource = (gridOptions, thresholdCount) => {
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientAPVendorDBWithToken();
			const columns = object.gridOptions.columnDefs;

			object.client
				.query(exploreLibraryQuery(params.request, columns, thresholdCount))
				.then(response => {
					let rows = response.data.aPVendorData;
					let lastRow = -1;
					if (rows.length <= gridOptions.cacheBlockSize) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default ServerSideDataSource;
